/*
  Node Styled Components

  Styled components for node UI elements to avoid inline styles
  and maintain consistency across the journey graph.
*/

import styled from 'styled-components';
import { BADGE_COLORS, EXPANDED_WORKFLOW } from './constants';

/**
 * Container for node content with flexible layout
 */
export const NodeContentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

/**
 * Text container that truncates with ellipsis
 */
export const TruncatedText = styled.span`
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/**
 * Status badge for displaying loading/error states
 */
export const StatusBadge = styled.span<{ variant: 'loading' | 'error' }>`
  padding: 0.125rem 0.5rem;
  font-size: 0.75rem;
  border-radius: 4px;
  background-color: ${({ variant }) => (variant === 'loading'
    ? BADGE_COLORS.LOADING.background
    : BADGE_COLORS.ERROR.background)};
  color: ${({ variant }) => (variant === 'loading'
    ? BADGE_COLORS.LOADING.text
    : BADGE_COLORS.ERROR.text)};
`;

/**
 * Container for expanded workflow view
 */
export const ExpandedWorkflowContainer = styled.div`
  padding: 0.5rem 1rem;
  background: ${EXPANDED_WORKFLOW.BACKGROUND};
  border: ${EXPANDED_WORKFLOW.BORDER_WIDTH}px solid ${EXPANDED_WORKFLOW.BORDER_COLOR};
  border-radius: ${EXPANDED_WORKFLOW.BORDER_RADIUS}px;
  min-width: ${EXPANDED_WORKFLOW.MIN_WIDTH}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

/**
 * Workflow info section in expanded view
 */
export const WorkflowInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

/**
 * Workflow name text
 */
export const WorkflowName = styled.span`
  font-size: 0.875rem;
  color: ${EXPANDED_WORKFLOW.TEXT_COLOR};
  font-weight: 600;
`;

/**
 * Workflow version text
 */
export const WorkflowVersion = styled.span`
  font-size: 0.75rem;
  color: ${EXPANDED_WORKFLOW.VERSION_TEXT_COLOR};
`;

/**
 * Collapse button for expanded workflow
 */
export const CollapseButton = styled.button`
  padding: 0.25rem 0.5rem;
  border: 1px solid ${EXPANDED_WORKFLOW.BORDER_COLOR};
  border-radius: 4px;
  background: #ffffff;
  cursor: pointer;
  font-size: 0.75rem;
  color: ${EXPANDED_WORKFLOW.BORDER_COLOR};
  
  &:hover {
    background: ${EXPANDED_WORKFLOW.BACKGROUND};
  }
`;

/**
 * Reconciliation node content container
 */
export const ReconciliationContent = styled.div`
  text-align: center;
  font-size: 10px;
`;

/**
 * Reconciliation node title
 */
export const ReconciliationTitle = styled.div`
  font-weight: 600;
  margin-bottom: 2px;
`;

/**
 * Reconciliation node subtitle
 */
export const ReconciliationSubtitle = styled.div`
  opacity: 0.8;
  font-size: 9px;
`;

